export interface AudioSegmentStore {
  appendPayload: (payload: ArrayBuffer) => void;
  readAllPcm: () => Uint8Array<ArrayBufferLike>;
  getByteLength: () => number;
  clear: () => void;
}

export class InMemoryAudioSegmentStore implements AudioSegmentStore {
  private readonly chunks: Uint8Array<ArrayBufferLike>[] = [];
  private byteLength = 0;

  appendPayload(payload: ArrayBuffer) {
    if (payload.byteLength === 0) {
      return;
    }

    const copy = new Uint8Array(payload.byteLength);
    copy.set(new Uint8Array(payload));
    this.chunks.push(copy);
    this.byteLength += copy.byteLength;
  }

  readAllPcm() {
    const combined = new Uint8Array(this.byteLength);
    let offset = 0;
    for (const chunk of this.chunks) {
      combined.set(chunk, offset);
      offset += chunk.byteLength;
    }
    return combined;
  }

  getByteLength() {
    return this.byteLength;
  }

  clear() {
    this.chunks.length = 0;
    this.byteLength = 0;
  }
}
